<template>
    <Page>
        <template #body>
            <div class="flex flex-column justify-content-center align-items-center">
                <span class="text-900 font-medium mb-4 xl:mb-6 text-center
                    text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                    flex xl:flex lg:flex md:flex">
                    {{header[lang].title}}
                </span>
                <span class="flex text-600 mb-4 mb-4 xl:mb-6 text-xl justify-content-center text-center line-height-3">
                    {{header[lang].subtitle}}
                </span>
                <i class="pi pi-envelope" style="font-size: 2.5rem; color: #708090"></i>
                <div class="flex mt-5 max-w-30rem w-full">
                    <form class="flex flex-column w-full p-fluid">
                        <Button type="submit" :label="buttons[lang].go" @click="go_transfer" class="mt-2 mb-3 p-button-lg w-full border-round-lg" />
                    </form>
                </div>
			</div>
        </template>
    </Page>
</template>

<script>
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            header: {
                en: {
                    title: "Confirm your email",
                    subtitle: "Make sure you have confirmed your email so we can send you notifications about the status of the transfer. If the letter has not arrived, check the spam folder.",
                } ,
                ru: {
                    title: "Подтвердите свою электронную почту",
                    subtitle: "Убедитесь, что вы подтвердили свою электронную почту, чтобы мы могли отправлять вам уведомления о статусах перевода. Если письмо не пришло, проверьте папку cпам.",
                } ,
            },
            buttons:  {
                en:{
                    go : "Go to transfer",
                },
                ru:{
                    go: "К переводу",
                }                 
            }
        }
    },
    components: {
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        go_transfer(){
            this.$router.push({path: '/'})
        },
    },
    computed: {
        lang() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        }
    },
    mounted(){

    },
    async beforeCreate () {

    },
}
</script>